// dashboardReducer.js
import {
  FETCH_TOP_ACTIVE_JOBS_REQUEST,
  FETCH_TOP_ACTIVE_JOBS_SUCCESS,
  FETCH_TOP_ACTIVE_JOBS_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  is_daily_visit: 0,
};

const fetchTopActiveJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOP_ACTIVE_JOBS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_TOP_ACTIVE_JOBS_SUCCESS:
      console.log("dashboardReducer121", action.payload);
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        is_daily_visit: action.payload.data.is_daily_visit,
        error: null,
      };
    case FETCH_TOP_ACTIVE_JOBS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
   
    default:
      return state;
  }
};

export default fetchTopActiveJobsReducer;
